import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SortingTagScanUnpublishableModalProps {
    visible: boolean;
    areaNames: string[];
    onContinue: () => void;
    onCancel: () => void;
}

const SortingTagScanUnpublishableModal: React.FC<SortingTagScanUnpublishableModalProps> = ({
    visible,
    areaNames,
    onContinue,
    onCancel,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={visible}
            title={
                <span style={{ fontSize: 18, fontWeight: 700 }}>
                    {t('delivery.routes.message.sortingTagScanUnpublishableConfirmTitle')}
                </span>
            }
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    {t('delivery.routes.message.sortingTagScanUnpublishableCancel')}
                </Button>,
                <Button key="continue" type="primary" onClick={onContinue}>
                    {t('delivery.routes.message.sortingTagScanUnpublishableContinue')}
                </Button>,
            ]}
        >
            <p style={{ fontSize: 16, margin: 0 }}>
                {t('delivery.routes.message.sortingTagScanUnpublishableConfirmContent', {
                    areaNames: areaNames.join('、'),
                })}
            </p>
        </Modal>
    );
};

export default SortingTagScanUnpublishableModal;
